import React from 'react';
import PricingCards from '../components/PricingCards/PricingCards';


function Pricing() {
  return (
    <div>
        <PricingCards />
    </div>
  )
}

export default Pricing;
